"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingCoreChargePayoutStatusEnum = void 0;
var BillingCoreChargePayoutStatusEnum;
(function (BillingCoreChargePayoutStatusEnum) {
  /**
   * Средства зачислены в доходы получателей выплаты.
   * Если выплаты автоматические, после инициализации выплаты
   * статус изменится на STARTED
   */
  BillingCoreChargePayoutStatusEnum["INCOME"] = "INCOME";
  /**
   * Начат процесс выплаты по начислению.
   * Детали выплат доступны в связаннаях выплатах
   * (выплат может быть более одной, так как среди получателей
   * может быть не только преподаватель, но и школа)
   */
  BillingCoreChargePayoutStatusEnum["STARTED"] = "STARTED";
  /**
   * Выплаты всем получателям прошли успешно
   */
  BillingCoreChargePayoutStatusEnum["SUCCESSFUL"] = "SUCCESSFUL";
  /**
   * Есть проблемы с выплатами одному или нескольким получателям.
   * Перейдите в раздел выплат, найдите выплтаы по данному чарджу,
   * проанализируйте ошибки в логе ошибок выплат.
   */
  BillingCoreChargePayoutStatusEnum["WARNING"] = "WARNING";
  /**
   * Критическая ошибка, выплтаны не инициализированы,
   * т.е. зачисление на счёт доходов не произошло (откуда производится выплата)
   */
  BillingCoreChargePayoutStatusEnum["ERROR"] = "ERROR";
})(BillingCoreChargePayoutStatusEnum = exports.BillingCoreChargePayoutStatusEnum || (exports.BillingCoreChargePayoutStatusEnum = {}));
